import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';
import resources from './locales';

/* eslint-disable */
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    fallbackLng: 'en',

    // have a common namespace used around the full app
    ns: [
      'terms', 'degree', 'duration', 'languages', 'actions',
      'app', 'courses', 'schools', 'help',
    ],
    defaultNS: 'app',

    debug: true,

    // interpolation: {
    //   escapeValue: false, // not needed for react!!
    // },

    react: {
      wait: true,
    },

    resources,
  }, (err, t) => {
    if (err) return console.log('something went wrong loading', err);
    return
  });

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.jsx